import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { ShieldCheck, KeyRound } from "lucide-react";
import { API, errText } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [showFallback, setShowFallback] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      login(data.token, data.user);
      nav("/", { replace: true });
    } catch (err) { setError(errText(err)); }
    setBusy(false);
  };

  return (
    <div className="sd-app flex items-center justify-center min-h-screen p-4">
      <div className="w-full max-w-md text-center">
        <h1 className="font-heading font-extrabold text-4xl tracking-tight">Support Desk</h1>
        <p className="font-script text-2xl text-amber-800 mt-1 mb-6">your customers, one chat away ✦</p>
        <div className="card-sticky p-8 space-y-4 fade-up" data-testid="sso-required-screen">
          <ShieldCheck size={36} className="mx-auto" />
          <h2 className="font-heading font-bold text-xl">Open Support Desk from SND CRM</h2>
          <p className="text-sm text-slate-700">Sign-in happens automatically via secure SSO — go to SND CRM and click the Support Desk link.</p>
          <a data-testid="open-crm-button" href="https://crm.gosnd.com" className="btn-tactile inline-block px-6 py-2.5 text-sm">Open SND CRM ↗</a>
          <div className="flex items-center gap-3 pt-1">
            <div className="flex-1 border-t-2 border-dashed border-[#131E3A]/30" />
            <span className="text-[10px] font-bold uppercase tracking-widest text-slate-500">or</span>
            <div className="flex-1 border-t-2 border-dashed border-[#131E3A]/30" />
          </div>
          {!showFallback ? (
            <button data-testid="login-fallback-toggle" onClick={() => setShowFallback(true)} className="btn-outline-tactile px-4 py-2 text-xs inline-flex items-center gap-1.5">
              <KeyRound size={13} /> Use email & password (fallback)
            </button>
          ) : (
            <form onSubmit={submit} className="space-y-3 text-left">
              <div>
                <label className="sd-label">Email</label>
                <input data-testid="login-email-input" className="sd-input mt-1" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@upcpl.com" />
              </div>
              <div>
                <label className="sd-label">Password</label>
                <input data-testid="login-password-input" className="sd-input mt-1" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" />
              </div>
              {error && <div data-testid="login-error" className="text-sm font-semibold text-red-700 bg-red-50 border-2 border-red-300 rounded-lg px-3 py-2">{error}</div>}
              <button data-testid="login-submit-button" className="btn-tactile w-full py-2.5" disabled={busy}>{busy ? "Signing in…" : "Sign In"}</button>
              <div className="text-center">
                <Link data-testid="forgot-password-link" to="/forgot-password" className="text-xs font-semibold underline">Forgot password?</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
